module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.6-86.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.6.md
// module id = 502
// module chunks = 340